/**
 * Template definitions
 */
export const TEMPLATES = [
  {
    id: "modern-gradient",
    name: "Modern Gradient",
    description:
      "Clean, contemporary design with vibrant gradients and modern typography.",
    preview:
      "https://images.pexels.com/photos/2774556/pexels-photo-2774556.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Gradient backgrounds",
      "Modern typography",
      "Responsive design",
      "Interactive elements",
      "Social media integration",
      "Mobile optimized",
    ],
    requirements: {
      images: "2-3 high-res",
      content: "Title, description",
      colors: "3-5 brand colors",
    },
  },
  {
    id: "corporate-social",
    name: "Corporate Social",
    description:
      "Professional and trustworthy design perfect for business events and conferences.",
    preview:
      "https://northwoodschool.co.za/wp-content/uploads/2023/10/golf-1.jpg",
    features: [
      "Professional layout",
      "Corporate styling",
      "Speaker showcase",
      "Agenda timeline",
      "Registration forms",
      "Contact information",
    ],
    requirements: {
      images: "1-2 professional",
      content: "Full event details",
      colors: "2-3 corporate colors",
    },
  },
  {
    id: "corporate-professional",
    name: "Corporate Professional",
    description:
      "Professional and trustworthy design perfect for business events and conferences.",
    preview:
      "https://images.pexels.com/photos/1181396/pexels-photo-1181396.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Professional layout",
      "Corporate styling",
      "Speaker showcase",
      "Agenda timeline",
      "Registration forms",
      "Contact information",
    ],
    requirements: {
      images: "1-2 professional",
      content: "Full event details",
      colors: "2-3 corporate colors",
    },
  },
  {
    id: "creative-artistic",
    name: "Creative & Artistic",
    description:
      "Bold and creative design with artistic elements for creative industry events.",
    preview:
      "https://images.pexels.com/photos/1190298/pexels-photo-1190298.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Artistic layouts",
      "Creative typography",
      "Visual storytelling",
      "Portfolio showcase",
      "Interactive galleries",
      "Animation effects",
    ],
    requirements: {
      images: "3-5 creative assets",
      content: "Creative brief",
      colors: "4-6 vibrant colors",
    },
  },
  {
    id: "minimalist-clean",
    name: "Minimalist Clean",
    description:
      "Simple, elegant design focusing on content with plenty of white space.",
    preview:
      "https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Clean layouts",
      "Minimal design",
      "Typography focus",
      "White space usage",
      "Simple navigation",
      "Fast loading",
    ],
    requirements: {
      images: "1-2 minimal",
      content: "Concise copy",
      colors: "1-2 accent colors",
    },
  },
];

/**
 * Color scheme definitions
 */
export const COLOR_SCHEMES = [
  {
    id: "vibrant",
    name: "Vibrant Orange",
    colors: ["#f97316", "#fb923c", "#fdba74", "#fed7aa"],
  },
  {
    id: "professional",
    name: "Professional Blue",
    colors: ["#3b82f6", "#60a5fa", "#93c5fd", "#dbeafe"],
  },
  {
    id: "elegant",
    name: "Elegant Purple",
    colors: ["#8b5cf6", "#a78bfa", "#c4b5fd", "#e9d5ff"],
  },
  {
    id: "nature",
    name: "Nature Green",
    colors: ["#22c55e", "#4ade80", "#86efac", "#bbf7d0"],
  },
  {
    id: "sunset",
    name: "Sunset Pink",
    colors: ["#f72585", "#ff006e", "#fb8500", "#ffb703"],
  },
];

/**
 * Default event data structure
 */
export const DEFAULT_EVENT_DATA = {
  title: "Tech Innovation Summit 2024",
  // Customizable hero title color (overrides default white hero text when set)
  // This is controlled from the Colors tab via the Event Title color picker.
  eventTitleColor: "#111827",
  subtitle: "Shaping the Future of Technology",
  description:
    "Join industry leaders, innovators, and tech enthusiasts for a day of groundbreaking insights and networking opportunities.",
  date: "2024-03-15",
  time: "09:00",
  location: "San Francisco Convention Center",
  capacity: "500",
  ctaText: "Register Now",
  features: [
    "Keynote Speakers",
    "Interactive Workshops",
    "Networking Sessions",
    "Tech Exhibitions",
  ],
  speakers: [
    { name: "Sarah Chen", title: "AI Research Director", avatar: "SC" },
    { name: "Marcus Rodriguez", title: "Startup Founder", avatar: "MR" },
    { name: "Dr. Emily Watson", title: "Tech Innovator", avatar: "EW" },
  ],
  // Simple agenda for in-person events (time-based overview of the day)
  // Each item: { startTime: string, endTime: string, title: string, description?: string }
  agenda: [],
  schedule: [],
  sponsors: [],
  bannerImage: "",
  logoImage: "",
  videoLink: "",
};

